/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Missing_HintInputs */

const vi_einvoice_credential_missing_hint = /** @type {(inputs: Einvoice_Credential_Missing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập tài khoản và mật khẩu MISA của bạn để tiếp tục thao tác hóa đơn.`)
};

/**

* @param {Einvoice_Credential_Missing_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_missing_hint = /** @type {((inputs?: Einvoice_Credential_Missing_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Missing_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_missing_hint(inputs)
});